<div class="command-request">
  <div class="command-request__header-container">
    <div class="command-request__header-container__header lx-section-title">Issue New Command</div>
    <div class="command-request__header-container__close lx-section-title" (click)="cancel()"><i
        class="lx-icon lx-close-x"></i></div>
  </div>
  <div class="command-request__input-container">
    <div class="command-request__input-container__label lx-label">Devices<span class="lx-validation-warning"> *</span>
    </div>
    <div class="command-request__input-container__serials">
      <textarea type="text" [(ngModel)]="serialNumbers" name="serials" id="serials"
        placeholder="Enter Device SerialNumber(comma separated)"></textarea>
    </div>

    <div class="command-request__input-container__label lx-label">Command<span class="lx-validation-warning"> *</span>
    </div>
    <select class="command-request__input-container__dropdown" name="command" [(ngModel)]="selectedCommand" required>
      <option value="undefined" disabled selected>Select Command</option>
      <option *ngFor="let command of commands" [value]="command">{{command}}</option>
    </select>

    <div class="command-request__input-container__label lx-label">Description<span class="lx-validation-warning">
        *</span></div>
    <div class="command-request__input-container__description">
      <textarea type="text" [(ngModel)]="description" autocomplete="off" name="description" id="description"
        placeholder="Enter reason for the command"></textarea>
    </div>
  </div>

  <div class="command-request__footer">
    <div class="command-request__footer__button-container">
      <button class="command-request__footer__button-container__button__cancel lx-btn lx-btn-secondary"
        (click)="cancel()"><span>Cancel</span></button>
      <button class="command-request__footer__button-container__button__submit lx-btn lx-btn-primary"
        (click)="submit()"><span>Issue Command</span></button>
    </div>
  </div>
</div>